module.exports = __webpack_public_path__ + "static/2045d119d397a1ab8682b05bbb8acb910566afc8bd72169c64d945c768a7e4e3-c10ab65178019cbac9312219f6ea091c.jpeg";